interface DaySeparatorProps {
  label: string;
  /** Ancora del tour `cronologia-redesign` (Task 12): passata SOLO sul primo separatore renderizzato. */
  dataTour?: string;
}

export function DaySeparator({ label, dataTour }: DaySeparatorProps) {
  if (!label) return null;

  return (
    <div className="flex justify-center sticky top-0 z-[2] my-1 mb-3" data-tour={dataTour}>
      <span className="text-[11px] font-medium text-[#787774] dark:text-gray-400 bg-[#F7F7F5] dark:bg-[#373C3F] border border-[rgba(55,53,47,0.09)] dark:border-[#3F4447] rounded-full px-3 py-0.5 shadow-sm">
        {label}
      </span>
    </div>
  );
}
